import { Component, Input, ViewChild, EventEmitter, Output } from '@angular/core';
import { BaseEntity } from '@base/entities/BaseEntities';
import { BasePageComponent } from '@base/component/BasePageComponent';
import { ServiceBagService, ServiceBagServices } from '@base/component/ServiceBag';
import { EnumLanguages, EnumPageDisplayModes, EnumPageEntitySources } from '@core/framework/sysenums.enum';
import { SysGlobals } from '@core/framework/sysglobals';
import { Utils } from '@core/helpers/Utils';
import { ToolbarSettings } from '@m4u-angular/base/classes/BaseClasses';
import { PdfViewerComponent } from '@m4u-angular/ui/components/pdf-viewer/pdf-viewer.component';

class State {
    PDFData: any
}

@Component({
    providers: ServiceBagServices,
    selector: 'm4u-printboxdialog',
    templateUrl: './printboxdialog.component.html',
    styleUrls: ['./printboxdialog.component.scss']
})
export class PrintBoxDialogComponent extends BasePageComponent<BaseEntity, State>
{
    @ViewChild('pdfViewer') pdfViewer: PdfViewerComponent;

    //Main property to store the data. Since additional operation needs to take place, use this method instead of state directly
    @Input() set PDFData(value: string | Blob) {
        if (typeof value === 'string') value = Utils.ConvertToBlob(value, 'application/pdf');
        this.State.PDFData = value;
    }

    @Input() FileName: string;
    @Input() Title: string;
    @Output() OnCustomPrint: EventEmitter<any> = new EventEmitter();

    constructor(A: ServiceBagService) {
        super(A, 'PrintBoxDialogComponent', BaseEntity, State, EnumPageDisplayModes.Dialog, EnumPageEntitySources.External);
    }

    //If custom title was set, return it
    override OnInitTitle(): string {
        if (this.Title == undefined) return undefined;
        return this.GetDefaultTitle() + ' - ' + this.Title;
    }

    protected OnGetToolbarSettings() {
        return {
            IsAllowPrint: true,
            OnPrintButtonClick: (e) => this.DoPrint()
        } as ToolbarSettings;
    }

    DoPrint() {
        if (this.OnCustomPrint.observers.length > 0) {
            //Emit custom event
            this.OnCustomPrint.emit();
            return;
        }
        //Send to print
        this.pdfViewer.instance.iframe.nativeElement.contentWindow.print();
    }
}
